export default __webpack_public_path__ + "static/media/illustration-algocare-w@3x.ed268a94.png";